/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AutoUploadAttachments/view.blocks to change it.
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function AutoUploadAttachments({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/MessageTools/External/Tools/AttachmentAction/InApp/AutoUploadAttachments"
  
}) {
  return null
}